<script>
    function onClickBackToTop() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
</script>

<div on:click={onClickBackToTop} style="width: 100%; height: 50px; background-color: white; justify-content: center; align-items: center; display: flex; cursor: pointer">
    <p style="color: black; font-size: 16px; text-align: center; margin-top: 17px; font-weight: bold">BACK TO TOP</p>
</div>

<div style="height: 50px" />